export enum NotificationTabType {
  ASSET = 'ASSET',
  DOCUMENT = 'DOCUMENT',
  METAVERSE_3D = 'METAVERSE_3D',
}
